import styled from 'styled-components'
import { grid, margin } from 'styled-system'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

const shouldForwardProp = prop => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div
  .attrs(({ columns }) => ({
    gridTemplateColumns: [
      `repeat(1, 1fr)`,
      `repeat(1, 1fr)`,
      `repeat(${Math.min(columns, 2)}, 1fr)`,
      `repeat(${Math.min(columns, 3)}, 1fr)`,
    ],
  }))
  .withConfig({ shouldForwardProp })`
  width: 100%;
  display: grid;
  grid-gap: 16px;

  ${margin}
  ${grid}
`
